import PageContainer from '../components/PageContainer';
import PageTitle from '../components/PageTitle';
import desktopImage from '../static/images/chi_siamo_desktop.png';
import mobileImage from '../static/images/chi_siamo_mobile.png';
import { useTranslation } from "react-i18next";
import SwistenableLogo from '../static/images/swisstainable/logo.png';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const WhoWeAre = () => {
    const { t } = useTranslation();
    return (
        <PageContainer desktopItems="center">
            <Helmet>
                <title>Chi siamo - TicinoWild</title>
                <meta name="description" content="Scopri chi siamo: TicinoWild è la piattaforma che valorizza il lato selvaggio del Ticino, connettendo viaggiatori e fornitori di esperienze outdoor sostenibili." />
                <link rel="canonical" href="https://ticinowild.ch/who-we-are" />
                <meta property="og:title" content="Chi siamo - TicinoWild" />
                <meta property="og:description" content="Scopri chi siamo: TicinoWild è la piattaforma che valorizza il lato selvaggio del Ticino, connettendo viaggiatori e fornitori di esperienze outdoor sostenibili." />
                <meta property="og:url" content="https://ticinowild.ch/who-we-are" />
                <meta name="twitter:title" content="Chi siamo - TicinoWild" />
                <meta name="twitter:description" content="Scopri chi siamo: TicinoWild è la piattaforma che valorizza il lato selvaggio del Ticino, connettendo viaggiatori e fornitori di esperienze outdoor sostenibili." />
            </Helmet>
            <PageTitle title={t('WhoWeAre.title')} />
            {/* Foto e titolo*/}
            <div className='flex flex-col md:flex-row-reverse items-center w-full xl:w-[1000px]'>
                {<div className='md:hidden'><img src={mobileImage} alt="Chi siamo mobile" /></div>}
                {<div className='hidden md:flex flex-[2]'><img src={desktopImage} alt="Chi siamo desktop" /></div>}
                <div className='font-signature text-[#b05704] flex-[1] flex justify-center text-3xl lg:text-3xl m-4'>{t('WhoWeAre.discoverWildSide')}</div>
            </div>
            {/* Testo */}
            <div className='w-full xl:w-[1000px] mx-4 pr-4 flex flex-col gap-y-4'>
                <p>
                    {t('WhoWeAre.first')}
                </p>
                <p>
                    {t('WhoWeAre.second')}
                </p>
                <p>
                    {t('WhoWeAre.third')}
                </p>
                <h3 className="mb-[-16px] text-[#225424]">{t('WhoWeAre.swisstainableTitle')}</h3>
                <p>
                    {t('WhoWeAre.swisstainableParagraph')} <Link to="https://www.swisstainable.com/it" className='text-[#225424] font-bold'>switzerland.com/it/swisstainable</Link>
                </p>
                <img src={SwistenableLogo} alt="Swisstainable Logo" className='w-[100px]' />
            </div>
        </PageContainer>
    )
}

export default WhoWeAre